export const uk = {
    cancel: 'Отменить',
    'crop-title': 'Кадрирование изображения',
    'min-size': 'Выбранное изображение меньше 450 пикселей по одной из сторон.',
    'min-size-16-9':
        'Выбранное изображение не может использоваться в широком формате  — размер изображения меньше 1080 × 607 пикселей.',
    'narrow-scale': 'Выбранная область слишком узкая',
    save: 'Сохранить',
    'standart-format': 'Стандартное изображение',
    tip: 'Выберите область для отображения в объявлении',
    'wide-format': 'Широкоформатное (16:9)',
    'wide-scale': 'Выбранная область слишком широкая'
};
